<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
<!--      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">

&lt;!&ndash;            <a-col :md="8" :sm="24">
              <a-form-item label="活动名称" prop="activityName">
                <a-input v-model="queryParam.activityName" placeholder="请输入活动名称" allow-clear/>
              </a-form-item>
            </a-col>&ndash;&gt;
            <template v-if="advanced">

            </template>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>-->
      <!-- 操作 -->
<!--      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['videoreward:activity:add']">
          <a-icon type="plus" />新增
        </a-button>
        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['videoreward:activity:edit']">
          <a-icon type="edit" />修改
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['videoreward:activity:remove']">
          <a-icon type="delete" />删除
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>-->
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="startDate" slot-scope="text, record">
          {{ parseTime(record.startDate,'{y}-{m}-{d}') }}
        </span>
        <span slot="endDate" slot-scope="text, record">
          {{ parseTime(record.endDate,'{y}-{m}-{d}') }}
        </span>
        <span slot="videoLikeExtraReward" slot-scope="text, record">
          {{ record.videoLikeExtraReward }} 元
        </span>
        <span slot="articleLikeExtraReward" slot-scope="text, record">
          {{ record.articleLikeExtraReward }} 元
        </span>
        <span slot="firstVideoReward" slot-scope="text, record">
          {{ record.firstVideoReward }} 元
        </span>
        <span slot="totalAmount" slot-scope="text, record">
          {{ record.totalAmount }} 元
        </span>
        <span slot="remainAmount" slot-scope="text, record">
          {{ record.remainAmount }} 元
        </span>
        <span slot="status" slot-scope="text, record">
          <a-badge :status="record.status === 0 ? 'success' : 'error'" :text="record.status === 0 ? '开启' : '关闭'" />
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['videoreward:activity:edit']">
            <a-icon type="edit" />修改
          </a>
<!--          <a-divider type="vertical" v-hasPermi="['videoreward:activity:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['videoreward:activity:remove']">
            <a-icon type="delete" />删除
          </a>-->
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageActivity, delActivity } from '@/api/videoreward/activity'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'VideoRewardActivity',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        id: null,
        activityName: null,
        startDate: null,
        endDate: null,
        likeThreshold: null,
        videoLikeExtraReward: null,
        articleLikeExtraReward: null,
        firstVideoReward: null,
        content: null,
        status: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '活动名称',
          dataIndex: 'activityName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '开始日期',
          dataIndex: 'startDate',
          scopedSlots: { customRender: 'startDate' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '结束日期',
          dataIndex: 'endDate',
          scopedSlots: { customRender: 'endDate' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '点赞达标门槛',
          dataIndex: 'likeThreshold',
          ellipsis: true,
          align: 'center',
          customRender: function (text) {
            return text + ' 个赞'
          }
        },
        {
          title: '视频达标奖励金额',
          dataIndex: 'videoLikeExtraReward',
          scopedSlots: { customRender: 'videoLikeExtraReward' },
          ellipsis: true,
          width: '9%',
          align: 'center'
        },
        {
          title: '文章达标奖励金额',
          dataIndex: 'articleLikeExtraReward',
          scopedSlots: { customRender: 'articleLikeExtraReward' },
          ellipsis: true,
          width: '9%',
          align: 'center'
        },
        {
          title: '发布视频奖励金额',
          dataIndex: 'firstVideoReward',
          scopedSlots: { customRender: 'firstVideoReward' },
          ellipsis: true,
          width: '9%',
          align: 'center'
        },
        {
          title: '奖金总额',
          dataIndex: 'totalAmount',
          scopedSlots: { customRender: 'totalAmount' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '剩余奖金',
          dataIndex: 'remainAmount',
          scopedSlots: { customRender: 'remainAmount' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '活动状态',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '10%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    /** 查询医生内容发布激励活动信息列表 */
    getList () {
      this.loading = true
      pageActivity(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        id: undefined,
        activityName: undefined,
        startDate: undefined,
        endDate: undefined,
        likeThreshold: undefined,
        videoLikeExtraReward: undefined,
        articleLikeExtraReward: undefined,
        firstVideoReward: undefined,
        content: undefined,
        status: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id": id}))
          return delActivity(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
          })
        },
        onCancel () {
          // 取消清空删除ids列表
          that.ids = []
        }
      })
    }
  }
}
</script>
